import React, { Component } from 'react';
import _ from 'underscore';
import { SortingContext } from "./SortingContext";

const langMap = {
	'islex_DA': 'DK',
	'islex_NO-N': 'NO',
	'islex_FI': 'FI',
	'islex_NO-B': 'NO',
	'islex_FO': 'FO',
	'islex_FRA': 'FR',
	'islex_TYS': 'DE',
	'islex_SE': 'SE',
	'islex_EN': 'EN',
	'islex_POL': 'POL'
}

class MalidCard extends Component {
	static contextType = SortingContext;
	constructor(props) {
		super(props);

		this.expandButtonClickHandler = this.expandButtonClickHandler.bind(this);

		let minimizedDatasets = localStorage.getItem('malid_minimized_datasets') ? JSON.parse(localStorage.getItem('malid_minimized_datasets')) : [];

		this.state = {
			initialized: false,
			minimized: minimizedDatasets.indexOf(this.props.database) > -1,
			showInfo: false
		}
	}

	expandButtonClickHandler() {
		this.setState({
			minimized: !this.state.minimized
		}, function() {
			let minimizedDatasets = localStorage.getItem('malid_minimized_datasets') ? JSON.parse(localStorage.getItem('malid_minimized_datasets')) : [];

			if (this.state.minimized) {
				minimizedDatasets.push(this.props.database);
			}
			else {
				minimizedDatasets = _.without(minimizedDatasets, this.props.database);
			}

			localStorage.setItem('malid_minimized_datasets', JSON.stringify(_.uniq(minimizedDatasets)));
		}.bind(this));
	}

	componentDidMount() {
		setTimeout(function() {
			this.setState({
				initialized: true
			});
		}.bind(this), 100);
	}

	componentDidUpdate(prevProps) {
		if (this.props.children !== prevProps.children) {
			this.setState({
				showInfo: false
			})
		}
	}

	render() {
		const isAnySortingEnabled = this.context;
		return (
			<div className={'card'+(this.props.database ? ' database-'+this.props.database : '')+(this.props.className ? ' '+this.props.className : '')+(this.state.initialized ? ' initialized' : '')+(this.state.minimized ? ' minimized' : '')+((!this.props.visible && !this.props.frontPage) || this.props.forceHidden ? ' hidden' : '')+(isAnySortingEnabled ? ' sorting-enabled' : '')}
				style={{
					transitionDelay: (this.props.count/10)+'s'
				}}
			>
				<div className={'card-header'+((!this.props.visible && !this.props.frontPage) ? ' hidden' : '')}
					style={this.state.minimized ? { cursor: 'pointer'} : null} onClick={() => {
						if (this.state.minimized) {
							this.expandButtonClickHandler();
						}
					}}>
					<div className='card-header-top-row'>
						<div className={`dict-flag ${this.props.database}-flag`}>
							{this.props.includeFlags && !this.props.frontPage && langMap[this.props.database] && (
								<img
									src={`/img/flags/${langMap[this.props.database]}.svg`}
									alt={langMap[this.props.database]}
								/>
							)}
						</div>
						<p className="malid-card-title">{this.props.title}</p>
						{
							!this.props.frontPage &&
							<button className="info-button" onClick={() => this.setState({
								showInfo: !this.state.showInfo
							})} />
						}

					</div>
					{
						this.props.subTitle && <div className="subtitle">{this.props.subTitle}</div>
					}
				</div>

				<div className="card-body">
					{
						(this.state.showInfo || this.props.frontPage) &&
						<p className={'card-text'+(!this.props.frontPage ? ' card-info' : '')} dangerouslySetInnerHTML={{__html: this.props.aboutText}} />
					}
					{
						this.state.showInfo && <hr/>
					}
					{
						!this.props.frontPage && !this.props.showInfo &&
						this.props.children
					}
				</div>

				<button className="expand-button" onClick={this.expandButtonClickHandler}>
					<span className="label">{this.state.minimized ? window.l('database_display_in_results') : window.l('database_hide_in_results')}</span>
					<span className="icon" />
				</button>
			</div>
		);
	}
}

export default MalidCard;



// WEBPACK FOOTER //
// ./src/components/MalidCard.js